
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter order details:</p>
      </div>
    </div>
  </div>
  <div class="form" *ngIf="order" [formGroup]="order.form">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required" for="orderName">Order Name:</label>
            <input class="form-control" id="orderName" formControlName="name" name="name" maxlength="100" required>
          </div>
          <div class="form-group col-lg-6">
            <label class="required" for="orderShippingDestination">Shipping Destination</label>
            <select class="form-control" id="orderShippingDestination" formControlName="shippingDestination" name="shippingDestination" required (change)="onShippingDestinationChanges()">
              <option *ngFor="let property of shippingDestinationValues" [value]="property[0]">{{property[1]}}</option>
            </select>
            <ng-template [ngIf]="order.form.value['itsmWarehouse'] &amp;&amp; order.form.value['itsmWarehouse'].id"><small class="ml-3 text-muted d-block">{{ order.form.value['itsmWarehouse'].name }}</small><small class="ml-3 text-muted d-block">{{ order.form.value['itsmWarehouse'].line1 }}</small><small class="ml-3 text-muted d-block">{{ order.form.value['itsmWarehouse'].city }}, {{ order.form.value['itsmWarehouse'].region }}</small><small class="ml-3 text-muted d-block">{{ order.form.value['itsmWarehouse'].country }} {{ order.form.value['itsmWarehouse'].regionAbbreviation }}</small></ng-template>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="estimatedHardwareOrderDatePicker">Estimated Hardaware Order Date</label>
            <datepicker class="right input-group-append" id="estimatedHardwareOrderDatePicker" formControlName="estimatedHardwareOrderDatePicker" (outputEvents)="DPToTxt('estimatedHardwareOrderDate')" showInput="estimatedHardwareOrderDate" showInputOnly="estimatedHardwareOrderDatePicker"></datepicker>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <label class="required" for="requestedDeliveryDatePicker">Customer Requested Delivery Date (CRDD in S4):</label>
            <datepicker class="right input-group-append" id="requestedDeliveryDatePicker" formControlName="requestedDeliveryDatePicker" (outputEvents)="DPToTxt('requestedDeliveryDate')" showInput="requestedDeliveryDate" showInputOnly="requestedDeliveryDatePicker"></datepicker>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="sourceName">Source Document Name:</label>
            <input class="form-control" id="sourceName" formControlName="sourceName" name="sourceName" type="text" maxlength="60">
          </div>
          <div class="form-group col-lg-6">
            <label for="sourceDocumentationLink">Source Documentation Link:</label>
            <input class="form-control" id="sourceDocumentationLink" formControlName="sourceDocumentationLink" name="sourceDocumentationLink" type="text" maxlength="2000">
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label class="control-label" for="orderDeliveryInformation">Delivery Information</label>
            <textarea class="form-control" id="orderDeliveryInformation" formControlName="deliveryInformation" name="deliveryInformation" maxlength="300" rows="4"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>